import { STANDARD_PHYS_DESCR_FIELDS } from './constants';

const KitPhysDescriptionFieldConfig = [...STANDARD_PHYS_DESCR_FIELDS];

export default KitPhysDescriptionFieldConfig;
